import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';

/**
 * WINE CELLAR (Винный погреб) — the UNDERCROFT cellar of Castle Hearthhold: an intimate, candlelit
 * tasting nook tucked beneath the keep.
 *
 * Composition: the HERO is the cosy candlelit TASTING TABLE dead-centre, ringed by four wood chairs
 * and pooled in candelabra + wall-torch warmth — the spot ducks gather to share a cup. A showpiece
 * CASK stands proudly against the north wall like a prized vintage on display. STORAGE is pushed
 * cleanly to the cool stone walls and reads as an ordered cellar, not a heap: a wine RACK on each
 * side wall, a stacked BARREL in each lower corner. The floor between is left open — the breathing
 * room IS the design.
 *
 * Geometry: zone (800,2300) 560×340 → centre (1080,2470). Doors on the N wall (x1080 → bailey), the E
 * wall (y2470 → gatehouse) and the W wall (y2470 → dungeon) are kept clear; dressing hugs the walls.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── Wine racks, one against each cool side wall (kept off the E/W door mouths at y2470). ──
  place(ctx, kit.wineRack(art, 70, 80), 860, 2380);
  place(ctx, kit.wineRack(art, 70, 80), 1300, 2380);

  // ── A single stacked barrel anchored in each lower corner — ordered storage, not scatter. ──
  place(ctx, kit.barrelStack(art), 900, 2570);
  place(ctx, kit.barrelStack(art), 1260, 2570);

  // ── The HERO accent: a showpiece cask centred against the north wall — the proud vintage on display. ──
  place(ctx, kit.cask(art), 1080, 2380);

  // ── The candlelit TASTING TABLE dead-centre with four wood chairs (a sit-able piece AT every anchor). ──
  place(ctx, kit.smallTable(art, 34), 1080, 2470);
  place(ctx, kit.woodChair(art, 0), 1010, 2470); // cellar-chair-1 (west, faces table)
  place(ctx, kit.woodChair(art, Math.PI), 1150, 2470); // cellar-chair-2 (east, faces table)
  place(ctx, kit.woodChair(art, Math.PI / 2), 1080, 2400); // cellar-chair-3 (north, faces table)
  place(ctx, kit.woodChair(art, -Math.PI / 2), 1080, 2540); // cellar-chair-4 (south, faces table)

  // ── POOL LIGHT: candelabra + wall-torch warmth pooling onto the table + the hero cask. ──
  place(ctx, kit.candelabra(art), 940, 2470);
  place(ctx, kit.wallTorch(art), 1220, 2470);
  place(ctx, kit.wallTorch(art), 1080, 2330);
};

export default decorate;
